// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/core.less
// module id = 45
// module chunks = 4 5 6 7 8 10